/**
 * @generated SignedSource<<318bbe1151b78a62239abbc472c2f8d5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeMonthly",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeCustPercentage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feeSelfPercentage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerFeeUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerFeeUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateAccountTPayload",
        "kind": "LinkedField",
        "name": "updateAccountTByAccountId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountT",
            "kind": "LinkedField",
            "name": "accountT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a2c88b0c860ec76615e520c98a77b132",
    "id": null,
    "metadata": {},
    "name": "ResellerFeeUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ResellerFeeUpdateMutation(\n  $input: UpdateAccountTByAccountIdInput!\n) {\n  updateAccountTByAccountId(input: $input) {\n    accountT {\n      accountId\n      feeMonthly\n      feeCustPercentage\n      feeSelfPercentage\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "af30b4ee8f532973e543710ae45ebcf6";

module.exports = node;
